"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Box = _interopRequireDefault(require("../../Layout/Box"));

var _Toast = _interopRequireDefault(require("./Toast"));

var _context = require("./context");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ToastList = function ToastList(_a) {
  var _b = _a.variant,
      variant = _b === void 0 ? 'topRight' : _b;
  var toasts = (0, _context.useToastState)().toasts;
  return toasts ? _react.default.createElement(_Box.default, {
    sx: {
      position: 'absolute',
      variant: "toaster.list." + variant
    }
  }, toasts.map(function (toast, index) {
    return _react.default.createElement(_Toast.default, {
      key: "toast-" + index,
      title: toast.title,
      description: toast.description,
      id: toast.id,
      variant: toast.variant,
      duration: toast.duration,
      autoDelete: toast.autoDelete
    });
  })) : null;
};

var _default = ToastList;
exports.default = _default;